import { Component, input, output, signal, OnDestroy } from '@angular/core';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons';
import { FlowpilotChatTitleComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/topbar/flowpilot-chat-title.component';

@Component({
  selector: 'app-flowpilot-topbar',
  imports: [FaIconComponent, FlowpilotChatTitleComponent],
  template: `
    <div
      class="bg-dune-0 dark:bg-dune-1000 relative flex h-[38px] w-full shrink-0 items-center gap-x-12 px-3">
      <fa-icon
        class="fa-xs dark:hover:bg-dune-800 hover:bg-dune-200/40 -mt-0.5 size-5 shrink-0 scale-y-[-1] cursor-pointer rounded"
        [class.invisible]="!showSidebarToggle()"
        [icon]="['fas', 'align-left']"
        (click)="onSidebarToggleClick()"
        (mouseenter)="onHoverSidebarToggle()"
        (mouseleave)="onLeaveSidebarToggle()" />

      <app-flowpilot-chat-title />

      <div
        class="from-dune-0 dark:from-dune-1000 pointer-events-none absolute top-full right-0 left-0 h-5 bg-linear-to-b to-transparent"></div>
    </div>
  `,
})
export class FlowpilotTopbarComponent implements OnDestroy {
  /** INPUTS **/
  /****/
  readonly showSidebarToggle = input<boolean>(false);

  /** OUTPUTS **/
  /****/
  readonly sidebarIconClicked = output<void>();

  /** PROPERTIES **/
  /****/
  private readonly _sidebarIconHovered = signal(false);

  public get sidebarIconHoveredSignal() {
    return this._sidebarIconHovered.asReadonly();
  }

  /****/
  private hoverTimeOut: NodeJS.Timeout | null = null;

  constructor(library: FaIconLibrary) {
    library.addIcons(faAlignLeft);
  }

  ngOnDestroy() {
    this.clearTimeout();
  }

  protected onSidebarToggleClick(): void {
    this.sidebarIconClicked.emit();
  }

  protected onHoverSidebarToggle() {
    this.clearTimeout();
    this._sidebarIconHovered.set(true);
  }

  protected onLeaveSidebarToggle() {
    this.hoverTimeOut = setTimeout(() => {
      this._sidebarIconHovered.set(false);
    }, 300);
  }

  private clearTimeout() {
    if (this.hoverTimeOut) clearTimeout(this.hoverTimeOut);
    this.hoverTimeOut = null;
  }
}
